import { FC } from 'react';
import { Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as LinkIcon } from 'src/assets/svg/link.svg';
import { ASSETS_BASE_URL, BRANDFOLDER_BASE_URL } from 'src/api/concierge';
import { getTheme } from 'src/utils/get-theme';

export const FaqRulesDocuments: FC = () => {
    const { t } = useTranslation();
    const { isHosTheme } = getTheme();

    return (
        <Stack gap="16px" marginTop="16px">
            <Link
                target="_blank"
                download
                href={
                    isHosTheme
                        ? `${BRANDFOLDER_BASE_URL}/2EZAWJN8/at/cww5n6chx6w7hxm47kfm799/House_of_Social_Wellbeing_Charter.pdf`
                        : `${ASSETS_BASE_URL}/docs/wellbeing-charter.pdf`
                }
                display="flex"
                alignItems="center"
                gap="8px"
            >
                <Typography variant="subtitle2">
                    {isHosTheme
                        ? t('faq_answer_home-rules_documents_wellbeing_hos')
                        : t('faq_answer_home-rules_documents_wellbeing')}
                </Typography>

                <LinkIcon />
            </Link>
        </Stack>
    );
};
